import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

import { CartModel } from '../../cart/cart.model';
import { Price } from '@common/pipes';
import { CartIconPipe } from '@common/cart-pipes';
import { ImageLoadingComponent } from '@common/image-loading/image-loading.component';
import { FocusRemoverDirective } from '@helper/focus-remover.directive';
import { ProductMeta } from '@proto/store/api/common/common';
import { CartBottomSheetService, ShoppingCartData } from '@service/cart-bottom-sheet.service';
import { LinkToUrl } from '@common/link-pipes';

@Component({
  selector: 'app-price-meta',
  templateUrl: './price-meta.component.html',
  styleUrls: ['./price-meta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, Price, ImageLoadingComponent, FocusRemoverDirective, CartIconPipe, LinkToUrl, RouterLink],
})
export class PriceMetaComponent {
  @Input({ required: true }) meta: ProductMeta | undefined;
  @Input() mobile = false;
  @Input() showCart = false;
  @Input() skuId = '';
  @Input() marginTop = 19;
  @Input() marginBottom = 13;

  constructor(
    public cartModel: CartModel,
    private cartService: CartBottomSheetService
  ) {}

  openCart(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    this.cartService.openCart(
      new ShoppingCartData(this.skuId || (this.meta?.productId ?? ''), 0, false, undefined, true, false)
    );
  }
}
